import { render, staticRenderFns } from "./SsoMicrosoftLoggedIn.vue?vue&type=template&id=39090e98&"
import script from "./SsoMicrosoftLoggedIn.vue?vue&type=script&lang=js&"
export * from "./SsoMicrosoftLoggedIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports